import * as Cesium from "cesium";
import { showAlert } from "helper";
import styled from "styled-components";
import { makeStyles } from "@mui/styles";
import { useDispatch } from "react-redux";
import ApiInterface from 'utils/ApiInterface';
import UpgradeModal from "components/UpgradeModal";
import React, { useEffect, useState } from "react";
import { AnnotationTypes } from "../../../src/constant";
import useViewerStore from '../../store-zustand/viewer';
import useProjectStore from '../../store-zustand/project';
import { Grid, Button, Box, Tooltip } from "@mui/material";
import { Wrapper, Content, FormItem } from '../ActionModal';
import TooltipIconButton from "components/TooltipIconButton";
import BlackSelect from "../../components/common/BlackSelect";
import { ManageAnnotationList, GetDrawnShape, ClearGlobalVariables } from '../MapView/MapUtils';
import { Close, HistoryOutlined, EditOutlined, CheckCircleOutline, MultilineChart, FlipToFront as FlipToFrontIcon, WbSunnyOutlined } from '@mui/icons-material';

const CustomTooltip = (props) => {
  const useStyles = makeStyles((theme) => ({
    tooltip: {
      color: "white",
      fontSize: "12px !important",
      backgroundColor: "#5A5A5A",
      borderRadius: 3,
      fontFamily: 'Roboto',
      padding: '8px 10px'
    }
  }));
  const classes = useStyles();
  return <Tooltip classes={classes} {...props} />;
}

const weather_button_style = {
  position: 'absolute',
  height: '31px',
  left: '14px',
  top: '14px',
  borderRadius: '3px',
  background: '#E5E5E5',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#707173',
  fontFamily: 'Roboto',
  outline: 'none',
  padding: '5px 8px'
}

const temperature_text_style = {
  fontFamily: 'Open Sans',
  fontSize: '15px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '18px',
  letterSpacing: '0em',
};

const CustomButton = styled(Button)`
  width: 100%;
  padding-top: 15px !important;
  padding-bottom: 15px !important;
`;

const CustomButtonWithBorder = styled(CustomButton)`
  border-right: 1px solid gray !important;
  border-radius: 0 !important;
`;

const FooterWrapper = styled(Grid)`
  border-top: 1px solid gray;
  background: #2F2F2F;

  .FooterButtonContainer {
    button {
      font-size: 12px;
      color: white;
    }
  }
`;

const ModalHeader = styled.div`  
  position: relative;
`;

const textMeasurementStyle = {
  marginRight: '10px'
}

const InfoLongLang = styled.p`
  font-size: 14px;
  margin: 0;
  padding: 10px 0px 10px 0px;
  line-height: 1.6em;
  color: ${({ theme }) => theme.textColor.secondary};
`;

const MeasurementValue = styled(Box)`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: rgb(222, 222, 222);
  font-family: Roboto;
  font-size: 15px;
  font-weight: 700;
`;

const DataMeasurementModal = (props) => {
  const dispatch = useDispatch();
  let measurementValue = props.measurementValue;
  const measurementUnit = props.measurementUnit;
  
  const [actualMeasurementvalue, setactualMeasurementvalue] = useState(measurementValue);
  const [actualMeasurementUnit, setactualMeasurementUnit] = useState('m');
  const [actualDimensions, setactualDimensions] = useState(props.geomType === 'Point' ? '3D' : '2D');
  const [finishDrawing, setfinishDrawing] = useState(false);
  const { currentAnnotationName, currentAnnotationDescription, setcurrentAnnotationName, setcurrentAnnotationDescription, setcurrentAnnotationIcon, setcurrentAnnotationColor, setcurrentPinSize, setcurrentAnnotationAlpha, setcurrentAnnotationWidth } = useProjectStore();
  const [upgradeModalIsOpen, setUpgradeModalIsOpen] = useState(false);
  const { viewer, setmapboxvisibility, Current_Temperature } = useViewerStore();
  const { currentAnnotationId, project_id, AddAnnotation, setcurrentAnnotationId, setsingleannotationeidtion } = useProjectStore();
  const [longitudeLatitude, setLongitudeLatitude] = useState('--');
  
  const geometrytype = props.geomType;
  const LongitudeLatitude = props.LonLat;
  const display_measurement = props.display_measurement;
  const Dimensions = ["2D", "3D"];
  const lengthDimensions = ['m', 'ft', 'ml', 'km', 'yr']
  
  useEffect(() => {
    if (props.LonLat === undefined || props.LonLat === '--') return;
    
    const parts = props.LonLat.split(',');
    const lon = Number(parseFloat(parts[0]).toFixed(4));
    const lat = Number(parseFloat(parts[1]).toFixed(4));
    setLongitudeLatitude(`${lon}, ${lat}`);
  }, [props.LonLat])

  useEffect(() => {
    if (window['finishdrawing']) setfinishDrawing(true);

  }, [window['finishdrawing']])
  
  useEffect(() => {
    onChangeUnit(actualMeasurementUnit);
    window['actualUnit'] = actualMeasurementUnit;
  }, [measurementValue, actualMeasurementUnit])

  const closeModal = () => {
    dispatch({ type: 'TOGGLE_MEASUREMENT_ENABLE', show: true });
    dispatch({ type: 'TOGGLE_PIN_ENABLE', show: true });
    dispatch({ type: 'SET_PROJECT_PANEL', panel: 'Single' });
    
    if (window.handlerDrawPointGeom) {
      window.handlerDrawPointGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
      window.handlerDrawPointGeom.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      delete (window.handlerDrawPointGeom);
    }
    
    if (window.handlerEditPolygonGeom) {
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_UP);
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOWN);
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
      window.handlerEditPolygonGeom.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
      delete (window.handlerEditPolygonGeom);
    }
    ClearGlobalVariables(viewer);
    document.getElementById("cesium-wrapper").style.cursor = 'default';
  }

  const UndoLastPoint = () => {
    if (window.hasOwnProperty('Shapepoints') & window.Shapepoints.length > 0) {
      window.Shapepoints.pop();
      window.activeShapePoints.pop();
      let vertexesobj = window.vertexeArray;
      let vertexeLength = window.vertexeArray.length;
      viewer.entities.remove(vertexesobj[vertexeLength - 1]);
      vertexesobj.pop();
    }
  }

  const saveAnnotation = async () => {
    let saveStatus;
    if (window.hasOwnProperty('CurrentMeasureShape')) {
      let hidealerts = true;
      saveStatus = await save_changes(hidealerts, false);
    }

    if (window.hasOwnProperty('CurrentPointCentroid') & window.hasOwnProperty('CurrentPointCentroidArrayFormat')) {
      let hidealerts = true;
      saveStatus = await save_pin(hidealerts, false);
    }

    if (saveStatus !== 'Error') {
      const annotation = ManageAnnotationList(viewer, saveStatus, currentAnnotationId, AnnotationTypes);
      dispatch({ type: 'TOGGLE_ANNOTATION_MODAL', show: false });
      setmapboxvisibility(0);
      setsingleannotationeidtion(annotation);
    } else {
      showAlert('error', 'An error occured while editing the Annotation.')
    }
  }

  function defineNewMeasurementValue(Factor, unit) {
    let value = 0;
    if (measurementUnit === 'm') {
      value = (parseFloat(measurementValue) * Factor).toFixed(2);
    } else if (measurementUnit === 'm²') {
      value = (parseFloat(measurementValue) * Math.pow(Factor, 2)).toFixed(2);
    }

    setactualMeasurementvalue(value);
    setactualMeasurementUnit(unit);
  }
  
  const onChangeUnit = (event) => {
    let LineDimension = event;
    switch (LineDimension) {
      case 'ft':
        defineNewMeasurementValue(3.28084, event);
        break;
      case 'ml':
        defineNewMeasurementValue(0.000621371, event);
        break;
      case 'km':
        defineNewMeasurementValue(0.001, event);
        break;
      case 'yr':
        defineNewMeasurementValue(1.09361, event);
        break;
      case 'm':
        defineNewMeasurementValue(1, event);
        break;
      default:
        defineNewMeasurementValue(1, 'm');
    }
  };

  const TwoDThreeDSwitch = (event) => {
    setactualDimensions(event);

    if (event === '2D') {
      window['straightShape'] = true;
      if (window.hasOwnProperty('taskingFeaturesArray')) {
        window.taskingFeaturesArray.map((obj, index) => {
          if (obj.name === "TaskingPolygon") obj.polygon.perPositionHeight.setValue(true);
        })
        if (window.activeShape) window.activeShape.polyline.clampToGround = false;
      }
      
      if (window['CurrentPinMarker']) {
        for (var i = 0; i < window['CurrentPinMarker'].length; i++) {
          window['CurrentPinMarker'].get(i).heightReference = Cesium.HeightReference.CLAMP_TO_GROUND;
        }
        setactualMeasurementvalue(window['currentPinHeight'])
      }
    } else {
      window['straightShape'] = false;
      if (window.hasOwnProperty('taskingFeaturesArray')) {
        window.taskingFeaturesArray.map((obj, index) => {
          if (obj.name === "TaskingPolygon") {
            obj.polygon.perPositionHeight.setValue(false);
          }
        })
        if (window.activeShape) {
          window.activeShape.polyline.clampToGround = true;
        }
      }

      if (window['CurrentPinMarker']) {
        for (var i = 0; i < window['CurrentPinMarker'].length; i++) {
          window['CurrentPinMarker'].get(i).heightReference = Cesium.HeightReference.NONE;
        }
        const height = Cesium.Cartographic.fromCartesian(window['CurrentPinMarker'].get(0).position).height;
        setactualMeasurementvalue(Math.round(height * 100) / 100)
      }
    }
  }
  
  const save_changes = async (hidealerts, addannotationtoviewer = true) => {
    let keyword = {};
    if (window.hasOwnProperty('CurrentMeasureShape')) {
      let geometryType = window.CurrentMeasureShape['GeometryType'];
      let shapeString = GetDrawnShape('CurrentMeasureShape', viewer);
      keyword.annotationGeometry = shapeString;
      keyword.annotationType = geometryType;
      keyword.annotationName = currentAnnotationName ? currentAnnotationName : keyword.annotationType === 'POLYLINE' ? 'Untitled Line' : 'Untitled Area';
      keyword.annotationDescription = currentAnnotationDescription || "";
      keyword.annotationCentroid = LongitudeLatitude;
      keyword.annotationInMeter = `${measurementValue} ${measurementUnit}`;
      keyword.annotationMeasurement = actualMeasurementvalue
      if (measurementUnit === 'm²') {
        keyword.annotationMeasurementUnit = `${actualMeasurementUnit}²`
      } else {
        keyword.annotationMeasurementUnit = actualMeasurementUnit
      }

      keyword.projectId = project_id;
      let defaultStyle = `{
        "FillColor": "${window.activeShape.FillColor.toCssHexString()}",
        "LineFillTransparency": ${window.activeShape.LineFillTransparency},
        "PolygonFillTransparency": ${window.activeShape.PolygonFillTransparency || 0.35},
        "LineWidth": ${window.activeShape.LineWidth},
        "PinName": "defaultMarker.svg",
        "pinwidth": 30,
        "pinheight": 30,
        "PinColor": "#487BF2",
        "PinMarker":"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJtYXJrZXJfc2ltcGxlX2xhcmdlIj4NCjxnIGlkPSIjYW5ub3RhdGlvbi1tYXJrZXIiPg0KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTQ2LjI1IDI1LjVDNDYuMjUgMzEuOTI1IDQxIDM5Ljk3NSAzMC44NSA0OS4yNzVMMzAgNTAuMDI1TDI5LjE1IDQ5LjI1QzE5IDM5Ljk3NSAxMy43NSAzMS45MjUgMTMuNzUgMjUuNUMxMy43NSAxNS45IDIwLjggOC43NSAzMCA4Ljc1QzM5LjIgOC43NSA0Ni4yNSAxNS44NzUgNDYuMjUgMjUuNVoiIGZpbGw9IndoaXRlIi8+DQo8cGF0aCBpZD0iVmVjdG9yXzIiIGQ9Ik0zMCA1QzQwLjUgNSA1MCAxMy4wNSA1MCAyNS41QzUwIDMzLjggNDMuMzI1IDQzLjYyNSAzMCA1NUMxNi42NzUgNDMuNjI1IDEwIDMzLjggMTAgMjUuNUMxMCAxMy4wNSAxOS41IDUgMzAgNVpNNDUgMjUuNUM0NSAxNi40MjUgMzguMzc1IDEwIDMwIDEwQzIxLjYyNSAxMCAxNSAxNi40MjUgMTUgMjUuNUMxNSAzMS4zNSAxOS44NzUgMzkuMSAzMCA0OC4zNUM0MC4xMjUgMzkuMSA0NSAzMS4zNSA0NSAyNS41Wk0zMCAzMEMyNy4yNSAzMCAyNSAyNy43NSAyNSAyNUMyNSAyMi4yNSAyNy4yNSAyMCAzMCAyMEMzMi43NSAyMCAzNSAyMi4yNSAzNSAyNUMzNSAyNy43NSAzMi43NSAzMCAzMCAzMFoiIGZpbGw9IiM0ODdCRjIiLz4NCjwvZz4NCjwvZz4NCjwvc3ZnPg0K",
        "Labelfontsize": "11px",
        "LabelfillColor": "#FFFFFF",
        "LabelVisibility": false,
        "Polygonoutlinecolor": "${window.activeShape.Polygonoutlinecolor.toCssHexString()}"
      }`

      keyword.annotationStyle = defaultStyle;
      const response = await AddAnnotation(keyword);

      if (response.length === 0 || response === 'Error') {
        if (hidealerts === false) {
          showAlert('error', 'An error occured while saving the Annotation.');
        } else {
          return 'Error';
        }
      } else {
        if (hidealerts === false) {
          showAlert('success', 'Annotation saved successfully!');
        }
        
        viewer.entities.remove(window.floatingPoint);
        viewer.entities.remove(window.activeShape);
        window.lineNodes.map((obj, index) => {
          viewer.entities.remove(obj);
        })
        delete (window.activeShapePoints);
        delete (window.Shapepoints);
        delete (window.lineNodes);
        delete (window.floatingPoint);

        window.taskingFeaturesArray.map((obj, index) => {
          viewer.entities.remove(obj);
        })
        window.taskingFeaturesArray = [];

        setcurrentAnnotationName('');
        setcurrentAnnotationDescription();
        setcurrentAnnotationIcon();
        setcurrentAnnotationColor();
        setcurrentAnnotationAlpha();
        setcurrentPinSize();
        setcurrentAnnotationWidth();
        dispatch({ type: 'SET_PROJECT_PANEL', panel: 'Single' });
        viewer.scene.screenSpaceCameraController.enableRotate = true;
        if (addannotationtoviewer) {
          setcurrentAnnotationId(response);
        }

        if (hidealerts === true) {
          return response;
        }
      }
    } else {
      if (hidealerts === false) {
        showAlert('error', 'An error occured while saving the new Annotation.');
      } else {
        return 'Error';
      }
    }
  }

  const save_pin = async (hidealerts, addannotationtoviewer = true) => {
    let keyword = {};
    if (window.hasOwnProperty('CurrentPointCentroid') & window.hasOwnProperty('CurrentPointCentroidArrayFormat')) {
      let lon = window.CurrentPointCentroidArrayFormat[0];
      let lat = window.CurrentPointCentroidArrayFormat[1];
      let height = window.CurrentPointCentroidArrayFormat[2];

      let shapeString = `POINT(${lon} ${lat} ${height})`;
      keyword.annotationGeometry = shapeString;
      keyword.annotationName = currentAnnotationName || 'Untitled Pin';
      keyword.annotationDescription = currentAnnotationDescription || LongitudeLatitude;
      keyword.annotationType = 'Point';
      keyword.annotationCentroid = LongitudeLatitude;
      keyword.annotationInMeter = `${window['currentPinHeight']} ${measurementUnit}`;
      keyword.annotationMeasurement = window['currentPinHeight']
      keyword.annotationMeasurementUnit = actualMeasurementUnit
      keyword.projectId = project_id;

      let defaultStyle = `{
          "FillColor": "#487BF2",
          "LineFillTransparency": 1,
          "PolygonFillTransparency": 0.35,
          "LineWidth": 3,
          "PinName": "defaultMarker.svg",
          "pinwidth": ${window['CurrentPinMarker'].pinwidth},
          "pinheight": ${window['CurrentPinMarker'].pinheight},
          "PinColor": "${window['CurrentPinMarker'].PinColor.toCssHexString()}",
          "PinMarker":"${window['CurrentPinMarker'].PinMarker}",
          "Labelfontsize": "11px",
          "LabelfillColor": "#FFFFFF",
          "LabelVisibility": false,
          "Polygonoutlinecolor": "#3B6DBD"
        }`
      keyword.annotationStyle = defaultStyle;

      const response = await AddAnnotation(keyword);
      if (response === "Error" || response.length === 0) {
        if (hidealerts === false) {
          showAlert('error', 'An error occured while saving the Pin Annotation.');
        }
        else {
          return 'Error';
        }
      } else {
        if (hidealerts === false) {
          showAlert('success', 'Annotation saved successfully!');
        }
        
        delete window['CurrentPointCentroid'];
        delete window['CurrentPointCentroidArrayFormat'];

        viewer.scene.primitives.remove(window['CurrentPinMarker']);
        delete window['CurrentPinMarker'];
        
        setcurrentAnnotationName('');
        setcurrentAnnotationDescription();
        setcurrentAnnotationIcon();
        setcurrentAnnotationColor();
        setcurrentAnnotationAlpha();
        setcurrentPinSize();
        setcurrentAnnotationWidth();
        dispatch({ type: 'SET_PROJECT_PANEL', panel: 'Single' });

        if (addannotationtoviewer) {
          setcurrentAnnotationId(response);
        }

        if (hidealerts === true) {
          return response;
        }

        dispatch({ type: 'SET_PROJECT_PANEL', panel: 'Single' });
      }

    } else {
      if (hidealerts === false) {
        showAlert('error', 'An error occured while saving the new Annotation.');
      } else {
        return 'Error';
      }
    }
  }

  const isUserFreemium = async () => {
    const userProfile = await ApiInterface.instance.userProfile().catch((error) => null)
    if (userProfile === null || 
        userProfile !== null && (userProfile.data.metadata?.plan === undefined || userProfile.data.metadata?.plan?.toLowerCase() === 'freemium')){
      return true;
    }
    return false;
  }

  const profile3D = () => {
    isUserFreemium().then(userFremium => {
      if (userFremium){
        setUpgradeModalIsOpen(true);
        return;
      }
      
      dispatch({ type: 'TOGGLE_CHART', show: true })
      var samplePositions = [];
      var cart3Positions = window.activeShapePoints;
      var cartoPositions = Cesium.Ellipsoid.WGS84.cartesianArrayToCartographicArray(cart3Positions)
      for (var i = 0; i < cartoPositions.length - 1; i++) {
        var start = cartoPositions[i];
        var end = cartoPositions[i + 1];
  
        var length = Cesium.Cartesian3.distance(cart3Positions[i], cart3Positions[i + 1]) * 4; //for every 0.25m
        for (var j = 0; j < length; j++) {
          var lon = Cesium.Math.lerp(start.longitude, end.longitude, j / length);
          var lat = Cesium.Math.lerp(start.latitude, end.latitude, j / length);
          var position = new Cesium.Cartographic(lon, lat);
          position.height = getHeight(window.MAIN_CESIUM_VIEWER, Cesium.Ellipsoid.WGS84.cartographicToCartesian(position))
          if (position.height !== undefined) {
            samplePositions.push(position);
          }
        }
      }
  
      dispatch({ type: 'SET_CHART_POINTS', points: samplePositions })
    });
  }

  function getHeight(viewer, cartesian) {
    if (viewer.scene.clampToHeightSupported) {
      const pickedResult = viewer.scene.clampToHeight(cartesian, viewer.entities._entities._array);
      if (pickedResult) {
        return Cesium.Ellipsoid.WGS84.cartesianToCartographic(pickedResult).height;
      }
    }
    return viewer.scene.globe.getHeight(Cesium.Ellipsoid.WGS84.cartesianToCartographic(cartesian))
  }

  return (
    <>
      {upgradeModalIsOpen && <UpgradeModal setIsOpen={setUpgradeModalIsOpen} templateName={'starter'} callOnClose={() => null}/>}
      <Wrapper>
        <ModalHeader>
          <CustomTooltip title="Local Weather" aria-label="local-weather" placement="bottom">
            <button style={weather_button_style} >
              <WbSunnyOutlined sx={{ fontSize: '20px' }}/>
              <span style={temperature_text_style}>{`${Current_Temperature}`}°C</span>
            </button>
          </CustomTooltip>
          <TooltipIconButton title="Close" ariaLabel="close" placement="bottom" onClick={closeModal} size={44} position="true" top={10} right={10}>
            <Close />
          </TooltipIconButton>
        </ModalHeader>
        <Content>
          {
            finishDrawing === false ? (
              <TooltipIconButton title="Undo Last Point" ariaLabel="MarkerEdit" placement="top" size={60} position="true" top={-29} right={30} bluebg="true" onClick={UndoLastPoint}>
                <HistoryOutlined />
              </TooltipIconButton>
            ) : (
              <TooltipIconButton title="Edit style" ariaLabel="MarkerEdit" placement="top" size={60} position="true" top={-29} right={30} bluebg="true" onClick={saveAnnotation}>
                <EditOutlined />
              </TooltipIconButton>
            )
          }
          <MeasurementValue>{geometrytype}</MeasurementValue>
          <InfoLongLang>Last Picked Point: {longitudeLatitude}</InfoLongLang>
          {
            display_measurement === true ? 
            (<MeasurementValue>
              <span style={textMeasurementStyle}>{actualMeasurementvalue}</span>
              {measurementUnit === 'm²' ? 
                (<FormItem style={{ paddingRight: 10 }} ><BlackSelect options={lengthDimensions.map((item) => ({ label: `${item}²`, value: item }))} value={actualMeasurementUnit} onChange={onChangeUnit}/></FormItem>) 
                : 
                (<FormItem style={{ paddingRight: 10 }} ><BlackSelect options={lengthDimensions.map((item) => ({ label: `${item}`, value: item }))} value={actualMeasurementUnit} onChange={onChangeUnit}/></FormItem>)
              }
              <FormItem>
                <BlackSelect options={Dimensions.map((item) => ({ label: item, value: item }))} value={actualDimensions} onChange={TwoDThreeDSwitch} />
              </FormItem>
              <TooltipIconButton title="Copy" ariaLabel="copy" placement="top" size={34}>
                <FlipToFrontIcon fontSize="large" />
              </TooltipIconButton>
            </MeasurementValue>) 
            : 
            (<></>)
          }
        </Content>
        <FooterWrapper container spacing={0}>
          <Grid size={6} className='FooterButtonContainer'>
            {
              window.hasOwnProperty('CurrentMeasureShape') ? (
                <CustomButtonWithBorder startIcon={<CheckCircleOutline/>} onClick={() => {save_changes(false)}}>Save Changes</CustomButtonWithBorder>             
              ) : (
                <CustomButtonWithBorder startIcon={<CheckCircleOutline/>} onClick={() => {save_pin(false)}}>Save Changes</CustomButtonWithBorder>
              )}
          </Grid>
          <Grid size={6} className='FooterButtonContainer'>
            <CustomButton startIcon={<MultilineChart />} onClick={profile3D}>
              3D Profile
            </CustomButton>
          </Grid>
        </FooterWrapper>   
      </Wrapper>
    </>
  );
};

export default DataMeasurementModal;